import { useEffect, useState } from "react";

function readSession<T>(key: string): T | null {
  try {
    const raw = sessionStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch (err) {
    console.error(`useGetCurrentSessionUser(${key}) parse failed`, err);
    return null;
  }
}

export function useGetCurrentSessionUser<T>(key: string): T | null {
  const [value, setValue] = useState<T | null>(() => readSession<T>(key));

  useEffect(() => {
    setValue(readSession<T>(key)); // refresh once on mount

    const refresh = () => setValue(readSession<T>(key));

    // Cross-tab updates
    const onStorage = (e: StorageEvent) => {
      if (e.key === null || e.key === key) refresh();
    };
    window.addEventListener("storage", onStorage);
    const onLocalUpdate = (e: Event) => {
      const detail = (e as CustomEvent<{ key: string }>).detail;
      if (!detail || detail.key === key) refresh();
    };
    window.addEventListener("session-storage", onLocalUpdate as EventListener);

    return () => {
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("session-storage", onLocalUpdate as EventListener);
    };
  }, [key]);

  return value;
}